import React from 'react'

import './signs.scss'
import { navigate } from 'gatsby'
import { navigateTo } from 'gatsby'
import { siteUrl } from "../../../shared/utils/siteUrl"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"


const Signs = ({ title, classIco, slug, itemActive, setPageChange }) => {
    // var news_info=props.dataProp
    const nextSign = () => {
        setPageChange(true)
        navigate(slug, { replace: true })
        // setTimeout(() => {
        //     navigateTo(slug)
        // }, 300);
        const userInfoEncrypt= encryptUserInfo()
        pushDataLayerEvent({
            event: "Interacciones - Horóscopo",
            category: "magazin",
            action: "click",
            label: title,
            sub_category:'Horóscopo',
            zodiac_sign:title,
            location: window.location.href,
            user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
            log_status: userInfoEncrypt.log_status,
        })
        if (process.env.ENVIRONMENT === "PDN") {
            window.location.href = siteUrl + '/magazin/horoscopo/' + slug
        } else {
            navigateTo(slug)
        }
    }

    return (
        <li onClick={nextSign} className={itemActive ? "f-header-horoscope-nav-sing f-header-horoscope-nav-sing-active" : "f-header-horoscope-nav-sing"}>
            <div className="f-header-horoscope-nav-sing-icon">
                <span className={classIco}></span>
            </div>
            <p>{title}</p>
        </li>
    )
}

export default Signs;
